export default __webpack_public_path__ + "static/media/amex.820ab827.svg";